/**
 * @description Groups a set of images to be displayed in a gallery
 * @param images - Array of images
 * @param type - Type of gallery
 * "mobile" -> Every Img gets its own view on mobile resolution
 * "singleView" -> One View for 2 Img, only works with exactly 2 img
 * "onlySingleImg" -> Every Img gets its own view not depending on resolution
 * @returns Array of grouped images
 */

import { ConfiguredCarCatalogImage } from '~/graphql/__generated__/graphql';

export const groupImageUrls = (
	images: Array<string | string[] | null | undefined>,
	type?: 'mobile' | 'singleView' | 'onlySingleImg',
) => {
	if (!images) return [];
	const is2dArray = images.every(Array.isArray);
	const buffer = is2dArray ? images.map((img) => img.filter(Boolean)) : [images.filter(Boolean)];

	const result: Array<string[]> = [];
	for (let i = 0; i < buffer.length; i++) {
		const group: Array<string> = buffer[i];
		if (type && ['mobile', 'onlySingleImg'].includes(type)) {
			group.map((img) => result.push([img]));
		} else if (type === 'singleView' && group.length === 2) {
			result.push(group?.slice(0, 2));
			for (let j = 2; j < group?.length; j++) {
				result.push([group[j]]);
			}
		} else if (group.length < 3) {
			group.map((img) => result.push([img]));
		} else {
			result.push(group?.slice(0, 3));
			for (let j = 3; j < group?.length; j++) {
				result.push([group[j]]);
			}
		}
	}
	return result;
};

export const groupMedia = (
	media: Array<Array<ConfiguredCarCatalogImage | null | undefined>>,
	type?: 'mobile' | 'singleView' | 'onlySingleImg',
) => {
	if (!media) return [];
	const is2dArray = media.every(Array.isArray);
	// eslint-disable-next-line
	// @ts-ignore
	const buffer = is2dArray ? media.map((item) => item.filter(Boolean)) : [media.filter(Boolean)];
	const result: Array<Array<ConfiguredCarCatalogImage>> = [];

	for (let i = 0; i < buffer.length; i++) {
		const group: Array<ConfiguredCarCatalogImage> = buffer[i];
		if (type && ['mobile', 'onlySingleImg'].includes(type)) {
			group.map((item) => result.push([item]));
		} else if (type === 'singleView' && group.length === 2) {
			result.push(group?.slice(0, 2));
			for (let j = 2; j < group?.length; j++) {
				result.push([group[j]]);
			}
		} else if (group.length < 3) {
			group.map((item) => result.push([item]));
		} else {
			if (group && Array.isArray(group)) {
				result.push(group?.slice(0, 3));
				for (let j = 3; j < group?.length; j++) {
					result.push([group[j]]);
				}
			}
		}
	}

	return result;
};
